"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var SettingApi = /** @class */ (function () {
    function SettingApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 获取系统设置,更新系统设置
     * @method GET 获取系统设置
     * @method PUT 更新系统设置
     *
     */
    SettingApi.prototype.Setting = function () {
        return this.http
            .url("/api/Setting")
            .addSecurityHeaders()
            .support('GET', 'PUT');
    };
    SettingApi.diOptions = di_1.default.options({
        name: "SettingApi",
        scope: "Singleton"
    });
    return SettingApi;
}());
exports.SettingApi = SettingApi;
exports.default = SettingApi;
